// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { IntervalType } from '@/costs/utils/date-utils';
import { IsoCurrencyCode } from '@/currency/constants/iso';
import {
  InventoryBridgeData,
  inventoryBridgeDataSchema,
} from '@/report/api/types';
import { DateTime } from 'luxon';
import { z } from 'zod';

const inventoryBridgeResponseSchema = z.object({
  data: inventoryBridgeDataSchema,
  metadata: responseMetadataSchema,
});

interface AssetBridgeParameters {
  startDate: DateTime;
  endDate: DateTime;
  interval: IntervalType;
  currency: IsoCurrencyCode;
}

export async function getInventoryBridgeData(
  params: AssetBridgeParameters
): Promise<InventoryBridgeData> {
  const startDateString = params.startDate.toISODate();
  const endDateString = params.endDate.toISODate();

  const path = '/v1/report/asset/inventory-bridge';
  const response = await api.get(path, {
    params: {
      startDate: startDateString,
      endDate: endDateString,
      interval: params.interval,
      currency: params.currency,
    },
  });

  const parsedData = await parseResponse(
    inventoryBridgeResponseSchema,
    response.data,
    {
      schemaName: 'InventoryBridge',
      endpoint: path,
    }
  );

  return parsedData.data;
}
